import Confirmation from "../Modal/Confirmation";
import { ModalProps } from "../Modal/Modal";
import useThemeHook from "@/shared/hooks/useThemeHook";
import { useModalMeta } from "@/shared/atoms/useModal";

const ThemeDeleteConfirmationModal = ({ onExit }: ModalProps) => {
  const [{ themeId }] = useModalMeta();
  const { removeTheme } = useThemeHook();

  return (
    <Confirmation
      isPending={removeTheme.isPending}
      onSuccess={() => {
        removeTheme.mutate(themeId, { onSuccess: () => onExit() });
      }}
      show={true}
      onExit={() => onExit()}
    />
  );
};

export default ThemeDeleteConfirmationModal;
